import React from "react";
import { styled, TableCell, TableRow } from "@mui/material";
import { useNavigate } from "react-router-dom";

const StyledTableRow = styled(TableRow)`
  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
`;

const ContactsTableRow = ({
  contact,
}) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`${contact.contactEntityId}`);
  };

  return (
    <StyledTableRow onClick={handleRowClick}>
      <TableCell component="th" scope="row">
        {contact.modifyDate}
      </TableCell>
      <TableCell align="right">{contact.email}</TableCell>
      <TableCell align="right">{contact.lastName}</TableCell>
      <TableCell align="right">{contact.firstName}</TableCell>
      <TableCell align="right">{contact.status}</TableCell>
    </StyledTableRow>
  );
};

export default ContactsTableRow;